import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { DATE_METRICS } from "@constants"
import { metric } from "@signals"


const OPTIONS = [
    { label: 'Hourly', value: DATE_METRICS.HOURLY },
    { label: 'Daily', value: DATE_METRICS.DAILY },
    { label: 'Weekly', value: DATE_METRICS.WEEKLY },
    { label: 'Monthly', value: DATE_METRICS.MONTHLY },
    { label: 'Quarterly', value: DATE_METRICS.QUARTERLY },
    { label: 'Yearly', value: DATE_METRICS.YEARLY }
]

export default function CommonFiltersMetricSelect({ ...props }) {
    return <SelectSeeker
        options={OPTIONS}
        label="Select Metric"
        value={metric.value}
        onChange={e => metric.value = e.target.value}
        {...props}
    />
}